// Regular expressions
const urlRegex = /(https?:\/\/[^\s[\]().]+(?:\.[^\s[\]().]+)+)/g;
const boldRegex = /\*\*(.*?)\*\*/g;
const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
const inlineCodeRegex = /`([^`]+?)`/g;
const fencedCodeBlockRegex = /```(\w+)?\n([\s\S]*?)```/g;

// Escape HTML
const escapeHtml = (str) =>
  str.replace(/&/g, "&amp;")
     .replace(/</g, "&lt;")
     .replace(/>/g, "&gt;");

// Convert Markdown tables to HTML
const convertMarkdownTableToHtml = (markdown) => {
  const lines = markdown.trim().split('\n');
  if (lines.length < 2) return markdown;

  const header = lines[0].trim().split('|').slice(1, -1).map(h => h.trim());
  const rows = lines.slice(2).map(line =>
    line.trim().split('|').slice(1, -1).map(cell => cell.trim())
  );

  let tableHtml = '<table><thead><tr>';
  header.forEach(h => {
    tableHtml += `<th>${h}</th>`;
  });
  tableHtml += '</tr></thead><tbody>';

  rows.forEach(row => {
    tableHtml += '<tr>';
    row.forEach(cell => {
      tableHtml += `<td>${cell}</td>`;
    });
    tableHtml += '</tr>';
  });

  tableHtml += '</tbody></table>';
  return tableHtml;
};

// Main formatting function
export const formatTextWithLinks = (text) => {
  if (!text || typeof text !== "string") {
    return { __html: "" };
  }

  // Markdown table conversion
  const tableRegex = /((?:\|.*\n)+)/g;
  text = text.replace(tableRegex, (match) => {
    try {
      return convertMarkdownTableToHtml(match);
    } catch {
      return match;
    }
  });

  // Code block (fenced) conversion
  text = text.replace(fencedCodeBlockRegex, (_, lang, code) => {
    const safeCode = escapeHtml(code.trim());
    return `<pre><code class="language-${lang || 'plain'}">${safeCode}</code></pre>`;
  });

  // Heading conversion
  text = text.replace(/^### (.*)$/gm, "<h3>$1</h3>");
  text = text.replace(/^#### (.*)$/gm, "<h4>$1</h4>");

  // Bold conversion
  text = text.replace(boldRegex, (_, p1) => `<b>${p1}</b>`);

  // Inline code
  text = text.replace(inlineCodeRegex, (_, code) => `<code>${escapeHtml(code)}</code>`);

  // URL links
  text = text.replace(urlRegex, (match) => {
    return `<a href="${match}" target="_blank" rel="noopener noreferrer">${match}</a>`;
  });

  // Email links
  const seenEmails = new Set();
  text = text.replace(emailRegex, (match) => {
    if (seenEmails.has(match)) return match;
    seenEmails.add(match);
    return `<a href="mailto:${match}">${match}</a>`;
  });

  return { __html: text };
};
